import { useMemo } from 'react';
import { PreviewAtcCellComponent } from '@cotera/client/v0/data-grid/atc';
import {
  BaseCellRenderer,
  CellComponentPropsWithModel,
} from '@cotera/client/v0/data-grid';
import { DG } from '@cotera/sdk/core';

type LlmConfig = {
  model: string;
  schedule: 'never' | 'daily' | 'hourly' | { cron: string };
  temperature: number;
  maxOutputTokens: number;
};

type PreviewCellRendererProps = {
  getEditorState: (columnName: string) => DG.DocumentEditor.DocumentState;
  getLlmConfig: (columnName: string) => LlmConfig | null;
  atcColumns?: string[];
  relName: string;
  isPreviewMode?: boolean;
};

export const usePreviewCellRenderer = ({
  getEditorState,
  getLlmConfig,
  atcColumns,
  relName,
  isPreviewMode = false,
}: PreviewCellRendererProps) => {
  return useMemo(() => {
    return (props: CellComponentPropsWithModel) => {
      const llmConfig = getLlmConfig(props.column.key);

      let previewColumns: string[] = [];
      if (atcColumns) {
        previewColumns = atcColumns;
      } else {
        previewColumns = props.model.columns
          .snapshot()
          .filter((x) => x.t === 'llm')
          .map((x) => x.key);
      }

      if (!llmConfig) {
        // If no config found, return base cell renderer
        return <BaseCellRenderer {...props} />;
      }

      return (
        <PreviewAtcCellComponent
          {...props}
          atcColumns={previewColumns}
          getEditorState={() => getEditorState(props.column.key)}
          relName={relName}
          llmConfig={llmConfig}
          isPreviewMode={isPreviewMode}
        />
      );
    };
  }, [getEditorState, getLlmConfig, atcColumns, relName, isPreviewMode]);
};
